module.exports = __webpack_public_path__ + "img/banner-3-tablet.0f88433.webp";